import { Link } from 'react-router-dom'
import { useCatalog } from '../hooks/useCatalog.js'
import WeaponArt from '../components/WeaponArt.jsx'

export default function NotFound() {
  const { getItem } = useCatalog()

  return (
    <div className="page container center" style={{ paddingTop: 80 }}>
      <div style={{ maxWidth: 460, margin: '0 auto', display: 'grid', gap: 18 }}>
        <div style={{ opacity: 0.5, transform: 'rotate(-8deg)' }}>
          <WeaponArt
            image={getItem('karambit-doppler').image}
            rarity="covert"
            size="lg"
            title="404"
          />
        </div>
        <span className="eyebrow" style={{ justifySelf: 'center' }}>
          Ошибка 404
        </span>
        <h1 style={{ fontSize: '2.4rem' }}>Такой страницы нет</h1>
        <p className="muted">
          Возможно, ссылка устарела или в адресе опечатка. Кейсы точно на месте.
        </p>
        <div className="row wrap" style={{ justifyContent: 'center', marginTop: 8 }}>
          <Link to="/" className="btn btn-primary">
            На главную
          </Link>
          <Link to="/cases" className="btn btn-ghost">
            К кейсам
          </Link>
        </div>
      </div>
    </div>
  )
}
